import { useState } from 'react';
import { getUseGuestHierarchyTrainingNotification } from '@/redux/launchDarkly';
import { useSelector } from 'react-redux';
import { useUrlQueryState } from '@/hooks/routes/useUrlQueryState';
import { useLocation } from 'react-router';
import { redirectToBackofficeV1 } from '@/utils/backoffice-v1';

type UseGuestHierarchyTraining = {
    displayNotification: boolean;
    isTrainingOpen: boolean;
    onCloseTraining: () => void;
    onOpenTraining: () => void;
};

export const useGuestHierarchyTraining = (): UseGuestHierarchyTraining => {
    const [query] = useUrlQueryState();
    const displayTraining = query.get('displayTraining');
    const [isTrainingOpen, setIsTrainingOpen] = useState(displayTraining === 'true');

    const displayNotification = useSelector(getUseGuestHierarchyTrainingNotification);

    const onOpenTraining = () => {
        setIsTrainingOpen(true);
    };

    const onCloseTraining = () => {
        displayTraining === 'true' ? redirectToBackofficeV1('/home/customers') : setIsTrainingOpen(false);
    };

    return {
        displayNotification: displayNotification && displayTraining !== 'true',
        isTrainingOpen,
        onCloseTraining,
        onOpenTraining,
    };
};
